{
  "width": 16,
  "height": 12,
  "tilewidth": 128,
  "tileheight": 64,
  "layers": [
    {
      "name": "ground",
      "data": [
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,2,2,2,2,2,0,0,0,0,0,1,1,1,1,
        1,1,2,2,2,2,2,0,0,0,0,0,1,1,1,1,
        1,1,2,2,2,2,2,0,0,0,0,0,0,0,0,1,
        1,1,2,2,2,2,2,0,0,0,0,0,0,0,0,1,
        1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,
        1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,
        1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,
        1,1,0,0,0,0,0,4,4,4,0,0,0,0,0,1,
        1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1
      ]
    },
    {
      "name": "objects",
      "data": [
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
      ]
    }
  ],
  "tilesets": [
    { "firstgid": 1, "name": "tiles", "image": "assets/tiles/stone.png", "tilewidth": 128, "tileheight": 64, "tilecount": 5 }
  ],
  "herbs": [
    { "id": "gancao", "tx": 3, "ty": 3, "icon": "herb_gancao" },
    { "id": "danggui", "tx": 4, "ty": 4, "icon": "herb_danggui" },
    { "id": "jinyinhua", "tx": 2, "ty": 5, "icon": "herb_jinyinhua" },
    { "id": "lingzhi", "tx": 3, "ty": 2, "icon": "herb_lingzhi" }
  ],
  "npcs": [
    { "id": "patient", "tx": 7, "ty": 7, "icon": "patient", "name": "咳嗽的老者", "dialog": "咳咳……小哥，能不能帮我采三株甘草？我这嗓子实在难受。" },
    { "id": "child", "tx": 9, "ty": 6, "icon": "child", "name": "药童", "dialog": "师父说药圃里的草要按时浇水，你可别踩坏咯！" }
  ],
  "playerStart": { "tx": 8, "ty": 10 },
  "blocks": [
    [8,2],[9,2],[7,2],[8,1],[9,1],
    [0,0],[0,1],[0,2],[0,3],[0,4],[0,5],[0,6],[0,7],[0,8],[0,9],[0,10],[0,11],
    [15,0],[15,1],[15,2],[15,3],[15,4],[15,5],[15,6],[15,7],[15,8],[15,9],[15,10],[15,11]
  ]
}
